<div class="specifications-data">
    <div [ngClass]="{'list-view': (sampleView === sampleDisplay.LIST),
    'form-horizontal': ((sampleView === sampleDisplay.LIST) || (sampleView === sampleDisplay.REVIEWANDCONFIRM)),
    'form-vertical grid-view': (sampleView === sampleDisplay.GRID),
    'form-width-dynamic': (sampleView === sampleDisplay.REVIEWANDCONFIRM)}">
        <div class="form-group">
            <div *ngIf="currentSample?.isSpecificationsAdded || !disableSpecification()" class="form-label-div">
                <span class="form-label specification-label"
                    [ngClass]="{'mandatory': isMandatoryParameterExists()}">{{'vbeiSpecifications' | translate}}
                    <span *ngIf = "showLabelClaimAsterick()" [ngClass]="{'grey': true}">&nbsp;*</span>
                </span>
            </div>
            <div class="form-input-div" [ngClass]="{'flex-grow': (currentSample?.isSpecificationsAdded)}">
                <div class="specifications-table-container" *ngIf="currentSample?.isSpecificationsAdded && columnHeaders">
                    <table class="p-datatable-bordered specifications-table">
                        <thead>
                            <tr>
                                <ng-container *ngFor="let col of columnHeaders">
                                    <th [attr.rowspan]="col.subCols ? '1' : '2'" *ngIf="col.visible"
                                    [attr.colspan]="col.subCols ? col.subCols.length : '1'"
                                    [ngClass]="{'text-center': col.subCols}">
                                    {{col.header}}
                                    </th>
                                </ng-container>
                            </tr>
                            <tr>
                                <ng-container *ngFor="let col of columnHeaders">
                                    <ng-container *ngIf="col.subCols && col.visible">
                                        <th *ngFor="let subCol of col.subCols">{{subCol.header}}</th>
                                    </ng-container>
                                </ng-container>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let specification of currentSample.specifications">
                                <tr *ngFor="let parameter of specification.parameters">
                                    <td *ngIf="specification.parameters[0] === parameter" class="parameters"
                                        [attr.rowspan]="specification.parameters.length">
                                        <div class="parameter">
                                            <span class="font-bold">[{{specification.testCode}}]</span> {{specification.testName}}
                                        </div>
                                    </td>

                                    <td class="parameters">
                                        <div class="parameter">
                                            {{parameter.parameterName}}<span class="code"
                                                *ngIf="parameter.required">*</span>
                                        </div>
                                    </td>

                                    <td>
                                        {{parameter.standardSpecification?.numeratorCode?.name}}
                                        <span class="div-inline divided-by">/</span>
                                        {{parameter.standardSpecification?.denominatorCode?.name}}
                                    </td>
                                    <td *ngIf="parameter.parameterType === ParameterType.Date">
                                        {{parameter.standardSpecification?.target | date: dateFormat}}
                                    </td>
                                    <td *ngIf="parameter.parameterType !== ParameterType.Date">
                                        {{parameter.standardSpecification?.target}}
                                    </td>
                                    <td>
                                        {{parameter.standardSpecification?.min}}
                                    </td>
                                    <td>
                                        {{parameter.standardSpecification?.max}}
                                    </td>
                                    <td *ngIf="parameter.servingSpecification && isVisibility">
                                        {{parameter.servingSpecification?.numeratorCode?.name}}
                                        <span class="div-inline divided-by">/</span>
                                        {{parameter.servingSpecification?.denominatorCode?.name}}
                                    </td>
                                    <td *ngIf="parameter.servingSpecification 
                                                && parameter.parameterType === ParameterType.Date && isVisibility">
                                        {{parameter.servingSpecification.target | date: dateFormat}}
                                    </td>
                                    <td *ngIf="parameter.servingSpecification 
                                                && parameter.parameterType !== ParameterType.Date && isVisibility">
                                        {{parameter.servingSpecification.target}}
                                    </td>
                                    <td *ngIf="parameter.servingSpecification && isVisibility">
                                        {{parameter.servingSpecification.min}}
                                    </td>
                                    <td *ngIf="parameter.servingSpecification && isVisibility">
                                        {{parameter.servingSpecification.max}}
                                    </td>

                                    <td *ngIf="parameter.dailyValueSpecification
                                                && parameter.parameterType === ParameterType.Date">
                                        {{parameter.dailyValueSpecification.target | date: dateFormat}}
                                    </td>
                                    <td *ngIf="parameter.dailyValueSpecification
                                                && parameter.parameterType !== ParameterType.Date">
                                        {{parameter.dailyValueSpecification.target}}
                                    </td>
                                    <td *ngIf="parameter.dailyValueSpecification">
                                        {{parameter.dailyValueSpecification.min}}
                                    </td>
                                    <td *ngIf="parameter.dailyValueSpecification">
                                        {{parameter.dailyValueSpecification.max}}
                                    </td>

                                    <td *ngIf="parameter.labelClaimSpecification
                                                && parameter.parameterType === ParameterType.Date">
                                        {{parameter.labelClaimSpecification.target | date: dateFormat}}
                                    </td>
                                    <td *ngIf="parameter.labelClaimSpecification
                                                && parameter.parameterType !== ParameterType.Date">
                                        {{parameter.labelClaimSpecification.target}}
                                    </td>
                                    <td *ngIf="parameter.labelClaimSpecification">
                                        {{parameter.labelClaimSpecification.min}}
                                    </td>
                                    <td *ngIf="parameter.labelClaimSpecification">
                                        {{parameter.labelClaimSpecification.max}}
                                    </td>

                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="!isReadOnly && !disableSpecification()">
                    <a class="specification-anchor anchor" (click)="showAddSpecificationsPanel()">
                        <i class="ei ei-plus"></i>&nbsp;{{'vbeiAddSpecification' | translate}}
                    </a>
                    <span class="info-msg" *ngIf = "showLabelClaimSpecHint()"
                     [ngClass]="{'red': showLabelClaimSpecHintInRed()}">
                     {{'vbeiLabelClaimSpecificationMandatoryMessage' | translate}}</span>
                </div>
            </div>
        </div>
    </div>
</div>